export default {
  'confirm-yes': 'Sim, confirmo',
  copay: 'Copagamento:',
  cancel: 'Cancelar',
  'order-status': 'Estado da encomenda:',
  'order-canceled': 'Encomenda cancelada',
  'confirmed-back-to-pharmacy': 'Devolução à farmácia confirmada',
  'on-its-way-to-pharmacy': 'A caminho da farmácia',
  'back-to-pharmacy': 'Devolvido à farmácia',
  'patient-signature': 'Assinatura do paciente',
  sign: 'Assinar',
  'select-order-type': 'Selecionar tipo de encomenda',
  'preferred-eta': 'Hora de entrega preferida',
  'recipient-instructions': 'Instruções especiais do destinatário',
  'add-special-instruction': 'Adicionar instrução especial',
  'unable-to-change-address': 'Não foi possível alterar a morada',
  'address-changed': 'Morada alterada com sucesso',
  'start-typing': 'Comece a escrever',
  'full-address': 'Morada completa',
  'street-address': 'Rua',
  zip: 'Código postal',
  city: 'Cidade',
  state: 'Estado',
  apt: 'Apartamento',
  'app-store': 'Transferir na App Store',
  'track-all-orders': 'Acompanhe todas as suas encomendas numa só app',
  zoom: 'ampliar',
  unzoom: 'reduzir',
  'close-photo': 'fechar',
  'feedback-call': 'Chamada',
  'feedback-message': 'Mensagem',
  'feedback-close': 'Fechar',
  close: 'Fechar',
}
